import React, { Component } from 'react';
import * as axios from 'axios';
import 'bootstrap'
import '../css/style.css'

import Header from '../components/Header';
import Info from '../components/Info';
import Service from '../components/Service';
import Quote from '../components/Quote';
import SocMed from '../components/SocMed';
import Footer from '../components/Footer';

class Landing extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    axios.get('https://private-6fe32-donasimasjid.apiary-mock.com/settings')
      .then(data => {
        this.setState(data.data.data);
      })
  }

  render() { 
    return (
      <div>
        <Header />
        <Info data={this.state} />
        <Service data={this.state} />
        <Quote />
        <SocMed />
        <Footer data={this.state} />
      </div>
    );
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/container/Landing.js